import React, { useRef, useEffect, useState, useCallback } from 'react'
import { useNavigate, Link } from 'react-router-dom'  
import { useTranslation } from 'react-i18next';
import LanguageToggle from '../components/LanguageToggle'
import MenuPopup from '../components/MenuPopup';

function PageNotFound({ onGoBack }) {
  const { t } = useTranslation();
  const navigate = useNavigate()
  const [showMenu, setShowMenu] = useState(false);
  
  return (
    <>
      <meta charSet="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
      <link rel="shortcut icon" href="assets/images/favicon.ico" type="image/x-icon" />
      <link rel="stylesheet" href="https://use.typekit.net/hiu4ulc.css" />
      <link rel="stylesheet" href="assets/css/styles.css?ver=2.6" />
      <title>T&amp;C | Britannia</title>
      <div className="page-wrapper">
        <div className="main-wrapper yellow-bg">
          {/*=============== DESKTOP SCREEN START ===============*/}
          <div className="d-frame-outer desktop-only">
            <img src="assets/images/desktop-star.webp" className="d-frame-star-bg" />
            <span className="d-frame-corner tl" />
            <span className="d-frame-corner tr" />
            <span className="d-frame-corner bl" />
            <span className="d-frame-corner br" />
            <div className="d-frame-border-outer">
              <div className="d-frame-border">
                <div className="d-frame-border-inner">
                  <div className="d-frame-canvas">
                    <div className="d-frame-content">
                      <div className="desktop-center">
                        <div className="desktop-content-box">
                          <h3>Thank you for your interest in participating in the</h3>
                          <img
                            src="assets/images/desktop-logo-milk-bikis.webp"
                            className="desktop-logo"
                            alt="Milk Bikis Logo"
                          />
                          <div className="desktop-qr-box">
                            <span className="qr-corner qr-corner-tl" />
                            <span className="qr-corner qr-corner-tr" />
                            <span className="qr-corner qr-corner-bl" />
                            <span className="qr-corner qr-corner-br" />
                            <div className="qr-left">
                              <p className="qr-text">
                                Please scan the QR code on your phone to enter the experience :
                              </p>
                            </div>
                            <div className="qr-right">
                              <img src="assets/images/desktop-qr.svg" alt="QR Code" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*=============== DESKTOP SCREEN END ===============*/}
 
          {/* ══ PERSISTENT FRAME ══ */}
          <div className="frame-outer mobile-only">
            <span className="frame-corner tl" />
            <span className="frame-corner tr" />
            <span className="frame-corner bl" />
            <span className="frame-corner br" />
            <div className="frame-border-outer">
              <div className="frame-border">
                <div className="frame-border-inner">
                  <div className="frame-canvas">
                    <div className="frame-content">

                      
                      {/* REWARD SCREEN START */}
                      <div className="kural-screen rwd-screen">
 
                        {/* TOP */}
                        <div className="kural-top">
                          <div className="kural-head-container">
                            <div className="logo-head">
                              <div className="camera-sc-logo-wrap">
                                <img src="assets/images/animate-britania-logo.webp" alt="Britannia" className="camera-sc-logo camera-sc-logo-1" />

                                <img src="assets/images/animate-milk-bikkis-logo.webp" alt="Milk Bikis" className="camera-sc-logo camera-sc-logo-2" />
                              </div>
                              <img src="assets/images/sign-up-head-text.webp" className="top-logo-text" alt="Top Logo" onClick={() => navigate("/home")} />

                              <div className="menu-bars" onClick={() => navigate("/menu")}>
                                <span></span>
                                <span></span>
                                <span></span>
                              </div>
                            </div>
                              {/* <LanguageToggle /> */}
                          </div>
                        </div>
 
                        {/* 404 CONTENT Start */}
                        <div className="cnt-error-container">
                          <img src="assets/images/404-num.webp" alt="" />
                          <img src="assets/images/pen.webp" alt="" className="pen-img" />
                          <p><span>Oops!</span> Looks like you have stepped away from the game. Head back in!</p>
                        </div>

                        {/* Submit Button */}
                        <button onClick={() => { window.location.href = "/home"; }} className="btn-next error-bottom-btn" type="button" id="langOkayBtn">
                          <span>Go Back</span>
                        </button>
                        {/* 404 CONTENT End */}
 
                        {/* BOTTOM STRIP */}
                        <div className="kural-bottom">
                          <div className="kural-steps">
                            <span>SCAN BISCUIT</span>
                            <img src="assets/images/right-arrow-icon.webp" className="arrow-img" />
                            <span>COMPLETE KURAL</span>
                            <img src="assets/images/right-arrow-icon.webp" className="arrow-img" />
                            <span>SEND VIDEO RECORDING</span>
                          </div>
                        </div>
 
                      </div>
                      {/* REWARD SCREEN END */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
 
            <div className="frame-footer">
              <p className="frame-footer-terms">
                <Link to="/tnc">{t("common.terms")}</Link> {t("common.and")} <Link to="/privacy-policy">{t("common.privacy")}</Link>
              </p>
            </div>
          </div>
          {/* /frame-outer */}
        </div>
      </div>
    </>
  )
}

export default PageNotFound
